
function Spinner({ size = 50, color = "##0ea5e9", message = "Loading..." }) {
  const spinnerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    border: `${size / 10}px solid ${color}`,
    borderTop: `${size / 10}px solid transparent`,
  };
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className="rounded-full animate-spin"
        style={spinnerStyle}
        aria-label="Loading"
      ></div>
      {message && <p className="text-sm text-gray-600">{message}</p>}
    </div>
  );
}

export default Spinner;